module.exports = __webpack_public_path__ + "static/sidemail-report-2e8eab5e108e4ffa72f6324be97b7ed7.png";